import {
  defaultSort,
  sortingCategories,
} from '../../../contexts/discoveryContext/utils/sortOptions';

export { defaultSort };

export const mainSortCategoriesObj = {};
export const mainSortCategoriesArray = [];
export const sortOptionsFlatObj = {};

const _sortOptionsConfig = {
  [sortingCategories.RECOMMENDED]: {
    label: 'Recommended',
    options: [
      {
        value: 0,
      },
    ],
  },
  [sortingCategories.DATE]: {
    label: 'Date',
    options: [
      {
        icon: 'arrow_down',
        value: {
          date: 'asc',
        },
      },
      {
        icon: 'arrow_up',
        value: {
          date: 'desc',
        },
      },
    ],
  },
  [sortingCategories.PRICE]: {
    label: 'Price',
    options: [
      {
        icon: 'arrow_down',
        value: {
          price: 'asc',
        },
      },
      {
        icon: 'arrow_up',
        value: {
          price: 'desc',
        },
      },
    ],
  },
};
Object.keys(_sortOptionsConfig).forEach((key) => {
  const el = _sortOptionsConfig[key];

  el.options = el.options.map((opt, _index) => {
    const id = `${key}-${_index}`;
    const option = {
      label: el.label,
      ...opt,
      id,
      parentId: key,
    };
    sortOptionsFlatObj[id] = option;
    return option;
  });

  const mainSortCategory = { ...el, id: key };
  mainSortCategoriesObj[key] = mainSortCategory;
  mainSortCategoriesArray.push(mainSortCategory);
});

export const getMainCategoryIdBySortId = (sortId) => {
  return sortOptionsFlatObj[sortId] && sortOptionsFlatObj[sortId].parentId;
};

export const getCategoryOption = (currentValue, sortingCategoryId) => {
  const categoryOptions = mainSortCategoriesObj[sortingCategoryId].options;
  const mainValue = categoryOptions[0].id;
  const secondValue = categoryOptions[1] && categoryOptions[1].id;

  if (currentValue && mainValue !== currentValue) {
    return mainValue;
  }

  if (secondValue) {
    return secondValue;
  }

  return mainValue;
};
